import { ErrorHandling } from "client/CommonComponents";
import { useSelector } from "react-redux";

const ErrorPage = () => {
    const commonApiError = useSelector((state:any) => state.CommonErrorHandlerReducer?.commonApiError)

  return (
    <ErrorHandling errorNumber={commonApiError?.ErrorCode} errorText={commonApiError?.ErrorMessage} data-attribute="ErrorPage_Default_ErrorHandling" />
  );
};

export default ErrorPage;
